module.exports = __webpack_public_path__ + "static/media/navImg.3721c794.png";